export const buildUserRecordHref = (userId) => {
  if (typeof userId !== 'string' && typeof userId !== 'number') return '';
  if (typeof userId === 'number' && (!Number.isFinite(userId) || userId <= 0))
    return '';
  const value = String(userId).trim();
  if (!value || value === '0' || value === 'NaN') return '';
  return `/litta-palmer/user/record?id=${encodeURIComponent(value)}`;
};
